import { render, staticRenderFns } from "./form-header.vue?vue&type=template&id=0d7f9941&scoped=true&"
import script from "./form-header.vue?vue&type=script&lang=js&"
export * from "./form-header.vue?vue&type=script&lang=js&"
import style0 from "./form-header.vue?vue&type=style&index=0&id=0d7f9941&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7f9941",
  null
  
)

component.options.__file = "form-header.vue"
export default component.exports